import { DESTINATION_LEVELS } from "app/constants";

type DestinationResort =
	| string
	| null
	| undefined
	| {
			isHotel?: unknown;
			code?: string | number;
			places?: { type: string; id: string }[];
			[key: string]: unknown;
	  };

export const buildSdpRotationUri = (
	destinationResort: DestinationResort,
	departureCityCode: string | number | undefined
): string | undefined => {
	if (!destinationResort || !departureCityCode || typeof destinationResort === "string") {
		return undefined;
	}
	const resortPlace = destinationResort.places
		? destinationResort.places.find(place => place.type === DESTINATION_LEVELS.RESORT)
		: undefined;
	const destinationId = destinationResort.isHotel
		? resortPlace && resortPlace.id
		: destinationResort.code;
	return destinationId ? `sdp${destinationId}-${departureCityCode}` : undefined;
};
